var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.permissionFleets.length > 0 ? _c('v-autocomplete', {
    attrs: {
      "value": _vm.selectedFleet,
      "items": _vm.permissionFleets,
      "item-text": "title",
      "item-value": "id",
      "return-object": "",
      "dense": "",
      "solo": "",
      "outlined": "",
      "flat": "",
      "auto-select-first": "",
      "hide-details": "",
      "autofocus": "",
      "loading": _vm.isLoading
    },
    on: {
      "change": _vm.onFleetChange
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.id))])], 1)];
      }
    }], null, false, 2827820021)
  }) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }